import React from 'react';
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import SumoTable from '../tables/sumoTable';
import Card from "@mui/material/Card";
import { useTranslation } from "react-i18next";

const LibrarySumo = () => {
    const { t } = useTranslation();
    return (
        <DashboardLayout>
            <Card style={{ marginTop: '3px', padding: '12px', height: '100%' }}>
                <Grid container item xs={12} md={12}>
                    <Grid container={true} p={2}>
                        <div className='rawContainerDiagrams'>
                            <div className='diagrammHeadTitle'>{t("sumo.libraryTitle")}</div>
                            <SumoTable />
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </DashboardLayout>
    );
};

export default LibrarySumo;